module.exports = __webpack_public_path__ + "static/media/resume_nickhart.f83691cc.pdf";